import { Link } from 'react-router-dom';
import { styled, Theme } from '@mui/material';

export const sxStyles = {
  areasOfStudyBg: {
    // TODO add color to library
    backgroundColor: '#F9F9F9',
  },
  titleWrap: (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '2.5rem',

    '& > h2:first-of-type': {
      color: theme.palette.primary.main,
    },
  }),
};

export const StyledAreasOfStudyInner = styled('section')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '1320px',
  width: '100%',
  padding: '2rem 1.25rem',
  margin: '0 auto',

  [theme.breakpoints.up('lg')]: {
    padding: '4rem 1.25rem',
  },
}));

export const StyledAreaCardsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '2rem',

  a: {
    marginBottom: 0,
  },

  [theme.breakpoints.up('sm')]: {
    justifyContent: 'start',
  },
}));

export const StyledExploreMoreLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '160px',
  width: '100%',
  height: '48px',
  marginLeft: '1rem',
  borderRadius: '2px',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  fontSize: theme.typography.button.fontSize,
  fontWeight: 600,

  '& > svg:first-of-type': {
    marginLeft: '0.625rem',
  },

  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },

  [theme.breakpoints.up('sm')]: {
    maxWidth: '182px',
  },
}));
